import { Fragment } from 'react';

import { getENV, type SitePreviewData } from '@libs/common-next';

import { getItems } from './config';
import css from './configuration.module.scss';
import { DatePicker } from './date-picker';
import { EnvironmentSelect } from './environment-select';
import { Switch } from './switch';
import { splitWarning } from './utils';

interface Props {
    state: SitePreviewData;
    onChange: (key: keyof SitePreviewData, value: SitePreviewData[keyof SitePreviewData]) => void;
}

export function Configuration({ state, onChange }: Props) {
    const items = getItems(getENV('NEXT_PUBLIC_APP_ENV'));

    return (
        <div className={css.list}>
            {items.map(item => {
                const [mainDesc, warning] = splitWarning(item.description);

                return (
                    <Fragment key={item.key}>
                        <div className={css.row}>
                            <div className={css.label}>
                                <span className={css.name}>{item.title}</span>
                                <span className={css.description}>{mainDesc}</span>
                                {warning && <span className={css.warning}>{warning}</span>}
                            </div>
                            {item.type === 'select' ? (
                                <EnvironmentSelect
                                    name={item.key}
                                    value={state[item.key]}
                                    options={item.options}
                                    onChange={onChange}
                                />
                            ) : item.type === 'switch' ? (
                                <Switch name={item.key} value={state[item.key]} onChange={onChange} />
                            ) : (
                                <DatePicker name={item.key} value={state[item.key]} onChange={onChange} />
                            )}
                        </div>
                        <div className={css.divider} />
                    </Fragment>
                );
            })}
        </div>
    );
}
